<template>
  <div class="main-wrapper">
    <div class="main">
      <div class="btn-bars">
        <b-button
          :variant="(tab === 'schema') ? 'primary' : 'flat-secondary'"
          @click="tab = 'schema'"
        >
          Схема зала
        </b-button>
        <b-button
          v-if="eventSimilar.length > 0"
          :variant="(tab === 'other_events') ? 'primary' : 'flat-secondary text-white'"
          @click="tab = 'other_events'"
        >
          Даты
        </b-button>
        <b-button
          v-if="showClose"
          variant="outline-secondary"
          class="btn-icon float-right widget-close"
          @click="closeWidgetAttention"
        >
          <feather-icon icon="XIcon" />
        </b-button>
      </div>
      <div
        v-show="tab === 'schema'"
        class="main-content"
      >
        <div
          v-if="event != null && event.status == 'active'"
          style="height: 100%"
        >
          <widget-payment-process
            :order-data="orderProcessData"
            :is-active="orderPaymentProcessActive"
            :payment-result="paymenResult"
            :order-id="orderId"
            :order-token="orderToken"
            @close="orderPaymentProcessActive = false"
          />
          <widget-order-process
            :is-active="orderProcessActive"
            :event-name="event.name"
            :event-datetime="event.datetime"
            :event="event"
            :booking-seat="bookingSeat"
            :show-modal-error-notification="showModalErrorNotification"
            :tickets="TList"
            :commission="commission"
            :t-promo="tPromo"
            :loading-state-pay="loadingStatePay"
            @setErrorTitle="setErrorTitle"
            @setErrorMessage="setErrorMessage"
            @done="goToPay"
            @doneQr="goToPayQr"
            @close="orderProcessActive = false"
            @removeElementFromSeats="removeElementFromSeats"
            @show-modal-corporate="openCorporateModal"
          />
          <div class="map-with-details">
            <div class="event-detail">
              <span>{{ event.name }} {{ event.ageLimit }} {{ event.additional_name ? '('+event.additional_name+')': '' }}</span>
              <span class="ml-lg-3 d-lg-inline ml-0 d-block"> {{ widgetFormatDate(event.datetime) }}</span>
            </div>
            <div
              v-show="priceGroups.length > 0 && priceZonesLoaded"
              class="mt-2 map-with-details__price-list"
            >
              <swiper
                ref="mySwiper"
                :options="swiperOptions"
              >
                <swiper-slide
                  v-for="price in priceGroups"
                  :key="price"
                  :style="{'color': getPriceColor(price, priceZoneMap[price])}"
                >
                  <b-badge
                    ref="badge"
                    :style="{'background-color': getPriceColor(price, priceZoneMap[price])}"
                    @click="backLight(priceZoneMap[price], $event)"
                  >
                    {{ price }} &#8381;
                  </b-badge>
                </swiper-slide>
              </swiper>
            </div>
            <div
              v-if="false"
              class="map-zoom-container"
            >
              <button
                class="map-zoom map-zoom-plus"
                @click="mapZoomPlus"
              >
                &plus;
              </button>
              <button
                class="map-zoom map-zoom-minus"
                @click="mapZoomMinus"
              >
                &minus;
              </button>
            </div>
            <div
              ref="mapOverflow"
              class="map-overflow"
            >
              <hall
                ref="hallMap"
                :hall-id="event.hall_id"
                :tooltip="true"
                :cursor-pointer="true"
                :get-db-seats="false"
                :tooltip-variant="1"
                :default-disabled="true"
                :is-widget="true"
                :disabled="disabledSeatsList"
                :tooltip-template="myTooltipTemplate()"
                :seat-marks-by-seat="seatMarksBySeat"
                :seat-marks-show-metadata="false"
                :enable-pan-zoom="true"
                :l-back-light="LBackLight"
                :is-visible-place-number="false"
                @mapLoaded="onMapLoaded"
                @seatClick="onSeatClick"
              />
            </div>
            <div class="tickets-panel-mob">
              <div class="tickets-panel-mob__dop">
                <div
                  id="ticketsListOverflow"
                  class="tickets-list-overflow"
                >
                  <div
                    v-if="TList.length > 0"
                    class="d-flex flex-column text-left"
                  >
                    <div
                      v-for="ticket in TList.slice().reverse()"
                      :key="ticket.id"
                      class="d-flex justify-content-between align-items-center my-1"
                      :style="{'color': getPriceColor(ticket.price)}"
                    >
                      <div>
                        <div>{{ ticket.row_sector }} ряд {{ ticket.seat_number }} место</div>
                        <small>{{ ticket.description }}</small>
                      </div>
                      <div>{{ formatMoney(ticket.price, "RUB") }}</div>
                      <div>
                        <b-button
                          class="btn-icon"
                          variant="flat-secondary"
                        >
                          <feather-icon
                            icon="XIcon"
                            size="12"
                            @click="removeTicket(ticket.id)"
                          />
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="TList.length > 0"
                  class="mb-2 tickets-list-order"
                  @click="showTicketsList"
                >
                  {{ TList.length }} {{ numWord(TList.length, ['билет', 'билета', 'билетов']) }}:
                  {{ formatMoney(priceTotal, "RUB") }}
                  <feather-icon
                    icon="ChevronDownIcon"
                    class="mr-0 ml-auto"
                  />
                </div>
              </div>
              <b-button
                variant="success"
                :disabled="TList.length <= 0"
                @click="orderProcessActive = true"
              >
                <span v-show="TList.length <= 0">Выберите места</span>
                <span v-show="TList.length > 0">Далее</span>
              </b-button>
            </div>
          </div>
          <div
            v-if="false"
            class="map-preview"
          >
            <div
              ref="mapPreviewFrame"
              class="map-frame"
              @mousedown="dragPreviewFrame = true"
              @mouseup="dragPreviewFrame = false"
              @mouseleave="dragPreviewFrame = false"
              @mouseout="dragPreviewFrame = false"
              @mousemove="dragFrame"
            />
          </div>
          <div
            v-show="TList.length > 0"
            class="tickets-panel"
          >
            <div style="flex-grow: 1">
              <ticket-list
                class="tickets-list"
                :tickets="TList"
                :show-status="false"
                :show-ticket-number="false"
                :compact-view="true"
                :max-ticket-as-card-mode="maxTicketsBuy+1"
                @remove="removeTicket"
              />
            </div>
            <div>
              <div class="d-flex align-items-center">
                <div>{{ TList.length }} {{ numWord(TList.length, ['билет', 'билета', 'билетов']) }}:
                  {{ formatMoney(priceTotal, "RUB") }}
                </div>
                <b-button
                  variant="success"
                  class="ml-1"
                  @click="orderProcessActiveBtn"
                >
                  Далее
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="text-center"
        >
          <b-spinner
            small
          />
        </div>
      </div>
      <div
        v-if="event != null && eventSimilar.length > 0"
        v-show="tab === 'other_events'"
        class="main-content main-content--scroll"
      >
        <div class="similar-title">
          <span>{{ event.name }}</span>
        </div>
        <div class="similar-wrp">
          <div class="similar-body">
            <div
              v-for="event in eventSimilar"
              :key="event.id"
              class="similar-item"
            >
              <b-row>
                <b-col class="align-self-center">
                  <b>{{ formatDateUTC(event.datetime, 'D MMMM, dddd, HH:mm') }} {{ event.additional_name ? '('+event.additional_name+')': '' }}</b>
                </b-col>
                <!--            <b-col
                              class="text-right"
                            >
                              билетов: {{ event.tickets.total }}
                            </b-col>-->
                <b-col
                  class="text-right"
                >
                  <b-button
                    variant="success"
                    :to="'/widget/'+event.id"
                  >
                    Выбрать
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
      <div class="main__attention">
        <div
          id="modalAttention"
          class="modal-attention"
        >
          <div class="modal-attention__header">
            <div class="modal-attention__title">
              Внимание!
            </div>
          </div>
          <div class="modal-attention__body">
            <p>Это действие приведет к потере введеных данных и нужно будет заполнять все заново.</p>
          </div>
          <div class="modal-attention__footer">
            <button
              class="btn btn-success"
              @click="closeWidget"
            >
              Принимаю
            </button>
            <button
              class="btn btn-outline-secondary"
              @click="closeWidgetCancel"
            >
              Отмена
            </button>
          </div>
        </div>
        <div
          id="modalBooked"
          class="modal-attention"
        >
          <div class="modal-attention__header">
            <div class="modal-attention__title">
              Нам очень жаль.
            </div>
          </div>
          <div class="modal-attention__body">
            <p>Пока вы&nbsp;оформляли заказ выбранные места уже забронировали.</p>
            <p>Выберите, пожалуйста, другие места.</p>
          </div>
          <div class="modal-attention__footer">
            <button
              class="btn btn-success"
              @click="selectSeetWidget"
            >
              Выбрать
            </button>
          </div>
        </div>
        <div
          id="notAvailable"
          class="modal-attention"
        >
          <div class="modal-attention__header">
            <div class="modal-attention__title">
              Продажа закрыта.
            </div>
          </div>
          <div class="modal-attention__body">
            <p>Выберите, пожалуйста, другое представление.</p>
          </div>
          <div class="modal-attention__footer">
            <button
              class="btn btn-success"
              @click="closeWidget"
            >
              Выбрать
            </button>
          </div>
        </div>
        <div
          id="modalMaxTicketsBuy"
          class="modal-attention"
          :class="{ show: showMaxTicketsBuy }"
        >
          <div class="modal-attention__header">
            <div class="modal-attention__title">
              Нам очень жаль.
            </div>
          </div>
          <div class="modal-attention__body">
            <p>В одном заказе не может быть более {{ maxTicketsBuy }} билетов</p>
          </div>
          <div class="modal-attention__footer">
            <button
              class="btn btn-outline-secondary"
              @click="closeModal"
            >
              Хорошо
            </button>
          </div>
        </div>
        <div
          id="errorNotification"
          class="modal-attention"
        >
          <div class="modal-attention__header">
            <div class="modal-attention__title">
              {{ errorTitle }}
            </div>
          </div>
          <div class="modal-attention__body">
            <p v-html="errorMessage" />
          </div>
          <div class="modal-attention__footer">
            <button
              class="btn btn-outline-secondary"
              @click="hideModalErrorNotification"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
      <div v-if="isCorporateModal"
        class="modal-corporate"
      >
        <div class="modal-corporate__inner">
          <div class="modal-corporate__header">
            <b-button
              variant="outline-secondary"
              class="modal-corporate__close btn-icon"
              @click="hideCorporateModal"
            >
              <feather-icon icon="XIcon" />
            </b-button>
            <div class="modal-corporate__title">
              <template v-if="!leadData.success">
                Мы&nbsp;заметили, что Вы&nbsp;наш постоянный Зритель и&nbsp;предлагаем Вам оформить заявку на&nbsp;корпоративное обслуживание
              </template>
              <template v-else>
                Ваша заявка принята, мы&nbsp;свяжемся с&nbsp;Вами в&nbsp;ближайшее время
              </template>
            </div>
          </div>
          <div v-if="!leadData.success" class="modal-corporate__body">
            <validation-observer
              #default="{ handleSubmit, invalid }"
              ref="refFormObserver"
            >
              <b-form
                @submit.prevent="handleSubmit(onSubmitLead)"
                @reset.prevent="resetForm"
              >
                <validation-provider
                  #default="validationContext"
                  name="Имя и фамилия"
                  rules="required"
                  vid="name"
                >
                  <b-form-group
                    label-for="name"
                    label="Имя и фамилия"
                  >
                    <b-form-input
                      id="name"
                      v-model="leadData.name"
                      trim
                      placeholder="Имя и фамилия"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  #default="validationContext"
                  name="Электронная почта"
                  rules="required|email"
                  vid="email"
                >
                  <b-form-group
                    label-for="email"
                    label="Почта"
                  >
                    <b-form-input
                      id="email"
                      v-model="leadData.email"
                      trim
                      placeholder="Электронная почта"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  #default="validationContext"
                  name="Номер телефона"
                  rules="required"
                  vid="phone"
                >
                  <b-form-group
                    label-for="phone"
                    label="Телефон"
                  >
                    <phone-field
                      id="phone"
                      v-model="leadData.phone"
                      autofocus
                      maxlength="18"
                      trim
                      placeholder="+7(999) 99-99-99"
                      :state="getValidationState(validationContext)"
                      validate
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <div class="mt-2 text-center">
                  <b-button
                    variant="success"
                    type="submit"
                    :disabled="loadingState"
                  >
                    <b-spinner
                      v-if="loadingState"
                      small
                    />
                    Отправить
                  </b-button>
                </div>
              </b-form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BButton,
  BSpinner,
  BBadge,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormText,
} from 'bootstrap-vue'
import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { ref, onMounted, watch } from '@vue/composition-api'
import hall from '@views/reference/hall/maps/hall'
import TicketList from '@views/events/TicketList'

import device from 'current-device'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import store from '@/store'
import helpers from '@/mixins/globalHelpers'
import { buildSeatMarksIndex } from '@/utils/seatMarks'
import phoneField from '@/libs/phone-field/PhoneFieldRu.vue'
import { localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import ru from 'vee-validate/dist/locale/ru.json'
import formValidation from '@core/comp-functions/forms/form-validation'
import { email, required } from '@validations'
import WidgetOrderProcess from './WidgetOrderProcess'
import WidgetPaymentProcess from './WidgetPaymentProcess'

Vue.component(FeatherIcon.name, FeatherIcon)

localize({ ru })
localize('ru')

export default {
  components: {
    Swiper,
    SwiperSlide,
    BRow,
    BCol,
    BButton,
    BSpinner,
    BBadge,
    hall,
    TicketList,
    FeatherIcon,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormText,
    phoneField,
    WidgetOrderProcess,
    WidgetPaymentProcess,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [helpers],
  props: {
    eventId: {
      type: Number,
      required: true,
    },
    maxTicketsBuy: {
      type: Number,
      default: 5,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    tPromo: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {
    setErrorTitle(msg) {
      this.errorTitle = msg
    },
    setErrorMessage(msg) {
      this.errorMessage = msg
    },
  },
  setup(props) {
    const tab = ref('schema')
    const event = ref(null)
    const seatMarksBySeat = ref({})
    const eventSimilar = ref([])
    const priceGroups = ref([])
    // const dragPreviewFrame = ref(false)
    // const mapOverflow = ref(null)
    const badge = ref(null)
    // const mapPreviewFrame = ref(null)
    const disabledSeatsList = ref([])
    const hallMap = ref()
    const bookingSeat = ref([])
    const TList = ref([])
    const priceTotal = ref(0)
    const orderProcessActive = ref(false)
    const orderPaymentProcessActive = ref(false)
    const orderProcessData = ref(null)
    const paymenResult = ref(null)
    const orderId = ref(null)
    const orderToken = ref(null)
    const priceZoneMap = {}
    const priceZones = ref([])
    const priceZonesLoaded = ref(false)
    const commission = ref(0)
    const showMaxTicketsBuy = ref(false)
    const errorTitle = ref('')
    const errorMessage = ref('')
    const LBackLight = ref([])
    const loadingStatePay = ref(false)
    const loadingState = ref(false)
    const analyticsInitiated = ref(false)
    const isCorporateModal = ref(false);
    const leadData = ref({
      name: '',
      email: '',
      phone: '',
      success: false,
    })
    const resetleadData = () => {
      leadData.value = JSON.parse(JSON.stringify(leadData))
    }
    const { refFormObserver, getValidationState, resetForm } = formValidation(leadData)

    const openHall = () => {
      window.parent.postMessage({ message: 'kassy_widget_hall' }, '*')
    }

    const confirmHall = () => {
      window.parent.postMessage({ message: 'kassy_widget_confirm' }, '*')
    }

    const isSeatAvailableForBooking = seat => +seat.price >= 0
      && seat.status === 'free'
      && seat.is_unavailable_by_quota !== true

    const getEvent = () => {
      store.dispatch('widget/getEvent', { id: props.eventId })
        .then(response => {
          event.value = response.data.data
          seatMarksBySeat.value = buildSeatMarksIndex(event.value?.seats?.data, { publicOnly: true })
          if (event.value.status !== 'active' || (!event.value.online_sale && !event.value.is_shared)) {
            orderProcessCancelSale('Выберите, пожалуйста, другое представление.','Продажа закрыта.')
          } else {
            response.data.meta.price_zones.forEach(zone => {
              priceZones.value.push({ color: zone.color, price: zone.price, id: zone.id })
            })
            priceZonesLoaded.value = true

            event.value.seats.data.forEach(seat => {
              if (isSeatAvailableForBooking(seat) && !priceGroups.value.includes(+seat.price)) {
                priceZoneMap[+seat.price] = seat.price_zone
                priceGroups.value.push(+seat.price)
              }
            })
            priceGroups.value.sort((a, b) => +a - +b)
            openHall()
          }
        })
    }

    const getSimilar = () => {
      store.dispatch('widget/getSimilar', { id: props.eventId })
        .then(response => {
          eventSimilar.value = response.data.events
        })
    }

    const getPriceColorByZoneId = zid => priceZones.value.find(item => item.id === zid)
    const getPriceColor = (price, pz = null) => {
      if (pz !== null) {
        const priceZone = getPriceColorByZoneId(pz)
        if (priceZone) {
          return priceZone.color
        }
      }
      const colors = [
        '#7367F0',
        '#EA5455',
        '#00CFE8',
        '#28C76F',
        '#A7932D',
        '#FF9F43',
        '#D5DA00',
      ]
      const index = priceGroups.value.indexOf(price)
      return colors[index]
    }

    // const dragFrame = e => {
    //   if (dragPreviewFrame.value) {
    //     const mapOverflowH = mapOverflow.value.offsetHeight
    //     const mapFrameH = mapPreviewFrame.value.offsetHeight
    //     const top = (e.target.offsetTop + e.offsetY) - (e.target.offsetHeight / 2)
    //     const maxTop = e.target.parentElement.offsetHeight - e.target.offsetHeight
    //     if (top >= 0 && top <= maxTop) {
    //       e.target.style.top = `${top}px`
    //
    //       const percent = (top / maxTop) * 100
    //       mapOverflow.value.scrollTop = percent * (mapOverflowH / mapFrameH)
    //     }
    //   }
    // }
    //
    // const setDragFrameHeight = () => {
    //   const mapOverflowH = mapOverflow.value.offsetHeight
    //   const mapOverflowW = mapOverflow.value.offsetWidth
    //   const mapFrameW = mapPreviewFrame.value.offsetWidth
    //   const mapFrameH = Math.round(mapFrameW * (mapOverflowH / mapOverflowW))
    //
    //   mapPreviewFrame.value.style.height = `${mapFrameH}px`
    // }
    //
    // const mapScroll = e => {
    //   mapOverflow.value.scrollTop += e.deltaY
    //
    //   const frameTop = (mapPreviewFrame.value.parentElement.offsetHeight - mapPreviewFrame.value.offsetHeight) * (mapOverflow.value.scrollTop / mapOverflow.value.offsetHeight)
    //   mapPreviewFrame.value.style.top = `${frameTop}px`
    // }

    const getEventSeatById = id => event.value.seats.data.filter(seat => seat.seat_id == id)[0]
    const myTooltipTemplate = () => '<b>#C# ₽</b><br>Зона: #Z#<br>Ряд: #R# Место: #M#'
    const getTooltipAttribute = (match, id, dbid) => {
      if (match === '#C#') {
        const seat = getEventSeatById(dbid)
        if (seat) {
          return seat.price
        }
      }
      if (match === '#Z#') {
        const seat = getEventSeatById(dbid)
        if (seat && typeof seat.sector_id !== 'undefined') {
          return seat.sector_name
        }
      }

      return ''
    }

    watch(bookingSeat, () => {
      TList.value = []
      bookingSeat.value.forEach(seat => {
        TList.value.push({
          id: seat.id,
          row_sector: seat.r,
          seat_number: seat.m,
          price: seat.price,
          description: seat.seatDescription,
          sector_name: seat.seatDescription,
        })
      })

      calcPriceTotal()
    }, { deep: true })

    onMounted(() => {
      getEvent()
      getSimilar()
      getCommission()
    })

    const onMapLoaded = () => {
      // setDragFrameHeight()
      const seatsToColor = []
      event.value.seats.data.forEach(seat => {
        if (isSeatAvailableForBooking(seat)) {
          seatsToColor.push({
            id: seat.seat_id,
            color: getPriceColor(+seat.price, seat.price_zone),
          })
        } else {
          disabledSeatsList.value.push(seat.seat_id)
        }
      })

      // Используем батчинг для массовой установки цветов
      if (seatsToColor.length > 0) {
        hallMap.value.setSeatsColorsBatch(seatsToColor)
      }
    }

    const removeElementFromSeats = id => {
      bookingSeat.value = bookingSeat.value.filter(item => item.id !== id)
      hallMap.value.unsetSelected(id)
    }

    const removeTicket = id => {
      if (orderProcessActive.value === true) return
      bookingSeat.value = bookingSeat.value.filter(item => item.id !== id)
      hallMap.value.unsetSelected(id)
    }
    const onSeatClick = (id, dbid) => {
      if (orderProcessActive.value === true) return
      const seat = getEventSeatById(dbid)
      if (seat) {
        const hasSeat = bookingSeat.value.filter(item => item.id === +seat.seat_id).length > 0
        if (!hasSeat) {
          if (!isSeatAvailableForBooking(seat)) {
            return
          }

          if (bookingSeat.value.length >= props.maxTicketsBuy) {
            showMaxTicketsBuy.value = true
            return
          }
          showMaxTicketsBuy.value = false
          bookingSeat.value.push({
            id: +dbid,
            price: +seat.price,
            m: +seat.seat_number,
            r: +seat.row_sector,
            seatDescription: seat.sector_name,
            color: getPriceColor(+seat.price, seat.price_zone),
            event_seat_id: seat.id,
          })

          hallMap.value.setSelected(dbid)
        } else {
          removeTicket(+dbid)
        }
      }
    }

    const calcPriceTotal = () => {
      let total = 0
      TList.value.forEach(ticket => {
        total += +ticket.price
      })

      priceTotal.value = total
    }

    const closeSberModal = () => {
      const scrollWrapper = document.getElementById('iframeScrollWrapper')
      document.body.removeChild(scrollWrapper)
    }

    const yaEcommerce = (bookingSeats, orderData, coupon) => {
      const products = []
      const orderId = orderData.id
      const eventName = orderData.event.name ?? ''
      const eventData = orderData.event_name
      const eventPlace = orderData.event.place_hall_name ?? ''
      const eventCoupon = orderData.promocode ?? orderData.event.promocode ?? coupon ?? ''

      bookingSeats.forEach(item => {
        products.push({
          id: item.id,
          category: eventPlace,
          brand: eventName,
          name: eventData,
          price: item.price,
          variant: item.seatDescription,
          position: `Ряд: ${item.r} Место: ${item.m}`,
          coupon: `${eventCoupon?.toUpperCase()}`,
        })
      })

      const ecommerceJson = {
        ecommerce: {
          currencyCode: 'RUB',
          purchase: {
            actionField: {
              id: `${orderId}`,
              coupon: `${eventCoupon?.toUpperCase()}`,
            },
            products,
          },
        },
      }

      window.parent.postMessage({ message: 'ecommerce', ecommerce: ecommerceJson }, '*')
    }

    const showModalErrorNotification = () => {
      const errorNotification = document.getElementById('errorNotification')
      errorNotification.classList.add('show')
    }

    const checkingPaymentStatusOrderWhenPayingByQRCode = order => {
      const queryParams = { token: order.token, type_payment_request: 'status', payment_system_type: order.payment_system_type }
      store
        .dispatch('widget/checkingPaymentStatusOrderWhenPayingByQRCode', { ...queryParams })
        .then(response => response.data)
        .then(response => {
          const { formUrl } = response.data

          if (!formUrl) {
            setTimeout(() => {
              checkingPaymentStatusOrderWhenPayingByQRCode(order)
            }, 5000)
            return
          }

          const mainModal = document.querySelector('.main')
          const mainContent = mainModal.querySelector('.main-content')

          if (mainContent) {
            const iframe = `<iframe src="${formUrl}" frameborder="0" width="100%" height="100%" allowfullscreen class="iframe-sber" ></iframe>`
            mainContent.innerHTML = iframe
          }
        })
        .catch(error => {
          setTimeout(() => {
            checkingPaymentStatusOrderWhenPayingByQRCode(order)
          }, 5000)
        })
    }

    const goToPayRemoveDisabled = () => {
      const btns = document.querySelectorAll('.gotopay')
      btns.forEach(btn => {
        btn.removeAttribute('disabled')
      })
    }

    const onSber = data => {
      loadingStatePay.value = true
      store
        .dispatch('widget/makeOrder', data)
        .then(response => response.data)
        .then(response => {
          const order = response.data

          orderToken.value = order.token

          const mainModal = document.querySelector('.main')
          const mainContent = mainModal.querySelector('.main-content')
          if (mainContent) {
            const innerHTML = `<iframe src="${order.link_for_payment}" frameborder="0" width="100%" height="100%" allowfullscreen class="iframe-sber" ></iframe>`
            mainContent.innerHTML = innerHTML
            yaEcommerce(bookingSeat.value, order, data.promocode)
          }

          // Если тип системы оплаты по qr коду проверяем статус оплаты
          if (['sber_pay', 'sbp_cbr', 'sbp_cbr_qr', 'qr_vtb'].includes(data.payment_system_type)) {
            checkingPaymentStatusOrderWhenPayingByQRCode(order)
          }

          orderProcessActive.value = false
          orderPaymentProcessActive.value = true
          loadingStatePay.value = false
        })
        .catch(error => {
          switch (error.response?.status) {
            case 500:
            case 400:
            case 403:
            case 422:
              orderProcessCancelSale(error.response.data.message, error.response.data.title)
              break
            case 503:
              errorTitle.value = error.response.data.title
              errorMessage.value = error.response.data.message
              showModalErrorNotification()
              break
            case 416:
              const modalBooked = document.getElementById('modalBooked')
              if (modalBooked) {
                modalBooked.classList.add('show')
              }
              break
            default:
              errorTitle.value = 'Ошибка'
              errorMessage.value = 'Что-то пошло не так.'
              showModalErrorNotification()
              break
          }
        })
        .finally(() => {
          goToPayRemoveDisabled()
        })
    }

    const goToPaySetDisabled = () => {
      const btns = document.querySelectorAll('.gotopay')
      btns.forEach(btn => {
        btn.setAttribute('disabled', 'disabled')
      })
    }

    const goToPay = (orderData, type) => {
      if (!bookingSeat.value || !bookingSeat.value.length) {
        errorTitle.value = 'Ошибка'
        errorMessage.value = 'Корзина пуста. Выберите места для оплаты.'
        showModalErrorNotification()
        return
      }
      goToPaySetDisabled()
      confirmHall()
      orderProcessData.value = orderData
      orderProcessData.value.event_id = event.value.id
      orderProcessData.value.seats = bookingSeat.value.map(ticket => ticket.event_seat_id)
      orderProcessData.value.amount = orderData.amount ?? priceTotal.value
      orderProcessData.value.is_widget = 1
      orderProcessData.value.payment_system_type = type
      onSber(orderProcessData.value)
    }

    const goToPayQr = (orderData, type) => {
      if (!bookingSeat.value || !bookingSeat.value.length) {
        errorTitle.value = 'Ошибка'
        errorMessage.value = 'Корзина пуста. Выберите места для оплаты.'
        showModalErrorNotification()
        return
      }
      goToPaySetDisabled()
      confirmHall()
      orderProcessData.value = orderData
      orderProcessData.value.event_id = event.value.id
      orderProcessData.value.seats = bookingSeat.value.map(ticket => ticket.event_seat_id)
      orderProcessData.value.amount = orderData.amount ?? priceTotal.value
      orderProcessData.value.is_widget = 1
      orderProcessData.value.payment_system_type = type
      onSber(orderProcessData.value)
    }

    const closeWidget = () => {
      window.parent.postMessage({ func: 'closeWidget' }, '*')
    }

    const closeNotCertifivate = () => {
      const notCertifivate = document.getElementById('notCertifivate')
      notCertifivate.classList.remove('show')
    }

    const closeWidgetAttention = () => {
      if (orderProcessActive.value === true) {
        // window.parent.postMessage({func: 'closeWidgetAttention',}, '*') вызов модального окна, не работает из-за CORS
        closeWidget()
      } else {
        closeWidget()
      }
    }
    const closeWidgetCancel = () => {
      window.parent.postMessage({
        func: 'closeWidgetCancel',
      }, '*')
    }
    const bookedWidget = () => {
      window.parent.postMessage({
        func: 'bookedWidget',
      }, '*')
    }
    const selectSeetWidget = () => {
      window.parent.postMessage({
        func: 'selectSeetWidget',
      }, '*')
    }
    const closeNotAvailable = () => {
      const notAvailable = document.getElementById('notAvailable')
      notAvailable.classList.remove('show')
      window.location.reload()
    }

    const getCommission = () => {
      const queryParams = {
        event_id: props.eventId,
        key: 'online_commission',
      }

      store
        .dispatch('widget/searchCommission', { ...queryParams })
        .then(response => {
          commission.value = response.data.commission
        })
    }

    const showTicketsList = e => {
      const target = e.currentTarget
      const listBlock = document.getElementById('ticketsListOverflow')
      target.classList.toggle('open')
      listBlock.classList.toggle('show')
    }

    const closeModal = () => {
      showMaxTicketsBuy.value = false
    }

    const hideModalErrorNotification = () => {
      const errorNotification = document.getElementById('errorNotification')
      errorNotification.classList.remove('show')
    }

    const hideCorporateModal = () => {
      isCorporateModal.value = false
      closeWidgetAttention()
    }

    const backLight = (zone, event) => {
      const { target } = event
      const parent = target.closest('.map-with-details__price-list')
      const child = parent.querySelectorAll('.badge')
      let isActive = true
      LBackLight.value = []
      if (target.classList.contains('active')) {
        target.classList.remove('active')
        isActive = false
      } else {
        for (let i = 0; i < child.length; i++) {
          child[i].classList.remove('active')
          target.classList.add('active')
        }
        isActive = true
      }
      LBackLight.value.push([zone, isActive])
    }

    const swiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        update() {
        },
      },
    }

    const initAnalytics = (id) => {
      if (analyticsInitiated.value) return

      window.parent.postMessage({
        message: 'tp_init_analytics',
        metrikaId: id
      }, '*')

      analyticsInitiated.value = true
    }

    watch(() => store.state.app.settings, (newSettings) => {
        if (newSettings?.number_metrika && newSettings.number_metrika_enabled) {
          initAnalytics(newSettings.number_metrika)
        }
      },
      { immediate: true, deep: true }
    )

    const orderProcessActiveBtn = () => {
      orderProcessActive.value = true
    }

    const orderProcessCancelSale = (message, title) => {
      const notAvailable = document.getElementById('notAvailable')
      const notAvailableTitle = notAvailable.querySelector('.modal-attention__title')
      const notAvailableMessage = notAvailable.querySelector('.modal-attention__body')
      const btnBars = document.querySelector('.btn-bars')
      const mainContent = document.querySelector('.main-content')
      if (notAvailableTitle) notAvailableTitle.textContent = title ?? 'Внимание!'
      if (notAvailableMessage) notAvailableMessage.textContent = message ?? ''
      notAvailable.classList.add('show')
      btnBars.classList.add('d-none')
      mainContent.classList.add('d-none')
    }

    const openCorporateModal = (data) => {
      leadData.value.name = data.name;
      leadData.value.phone = data.phone;
      leadData.value.email = data.email;
      isCorporateModal.value = data.limit_exceeded;
    };

    const onSubmitLead = () => {
      loadingState.value = true
      store.dispatch('widget/addLead', leadData.value).then(response => {
        loadingState.value = false
        const responseData = response.data
        if (responseData && responseData.success) {
          leadData.value.success = true
        }
      }).catch(error => {
        loadingState.value = false
      })
    }

    return {
      tab,
      event,
      seatMarksBySeat,
      priceGroups,
      getPriceColor,
      // dragFrame,
      // dragPreviewFrame,
      // mapOverflow,
      onMapLoaded,
      // mapPreviewFrame,
      // mapScroll,
      disabledSeatsList,
      hallMap,
      myTooltipTemplate,
      getTooltipAttribute,
      onSeatClick,
      TList,
      priceTotal,
      removeTicket,
      goToPay,
      goToPayQr,
      orderProcessActive,
      orderPaymentProcessActive,
      orderProcessData,
      eventSimilar,
      bookingSeat,
      closeWidget,
      closeWidgetAttention,
      closeWidgetCancel,
      bookedWidget,
      selectSeetWidget,
      closeNotAvailable,
      paymenResult,
      orderId,
      orderToken,
      // mapZoomPlus,
      // mapZoomMinus,
      priceZonesLoaded,
      priceZones,
      priceZoneMap,
      getCommission,
      commission,
      showTicketsList,
      showMaxTicketsBuy,
      closeModal,
      openHall,
      confirmHall,
      errorTitle,
      errorMessage,
      hideModalErrorNotification,
      showModalErrorNotification,
      closeNotCertifivate,
      backLight,
      LBackLight,
      getEventSeatById,
      yaEcommerce,
      loadingStatePay,
      removeElementFromSeats,
      swiperOptions,
      orderProcessActiveBtn,
      openCorporateModal,
      isCorporateModal,
      onSubmitLead,
      leadData,
      getValidationState,
      refFormObserver,
      resetForm,
      hideCorporateModal,
      loadingState,
    }
  },
}
</script>
<style scoped lang="scss">
@import '~@core/scss/vue/libs/swiper.scss';
@import '~swiper/css/swiper.css';
$mobile: 899px;
.btn-bars {
  @media (max-width: $mobile) {
    padding: 10px
  }
}

.btn-bars .widget-close {
  background-color: #fff !important;
  border: none !important;
  box-shadow: 0 3px 8px rgba(167, 174, 181, 0.4);
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;

  &:hover {
    opacity: .7;
  }

  .feather {
    width: 20px;
    height: 20px;
  }
}

.main-wrapper {
  height: 100%;
  overflow: hidden;
}

.main {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;

  &__attention {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    &.long {
      max-width: 576px;

      a {
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 100%;
    &__attention {
      width: 90%;
      margin: auto;
    }
  }
}

.main-content {
  position: relative;
  margin-top: 24px;
  background: #FFFFFF;
  border-radius: 6px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  padding: 35px;
  flex-grow: 1;
  overflow: hidden;
  @media (max-width: $mobile) {
    height: calc(100% - 65px);
    padding: 10px;
    margin-top: 0;
  }
}

.event-detail {
  font-weight: 600;
  font-size: 14px;
  color: #6E6B7B;
}

.map-overflow {
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  @media (max-width: $mobile) {
    height: 100%;
  }
}

.map-preview {
  width: 128px;
  height: 128px;
  position: absolute;
  top: 35px;
  right: 35px;
  border-radius: 50%;
  background-image: url("data:image/svg+xml,%3Csvg width='99' height='99' viewBox='0 0 99 99' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M46.0384 0.421875C34.3726 1.20755 23.8243 6.06982 15.8059 13.596L36.0733 33.8633C38.8485 31.4814 42.2699 29.8308 46.0384 29.2105V0.421875ZM13.9559 15.4265C6.3053 23.4063 1.32425 33.9657 0.448044 45.6694H29.273C29.9711 41.8675 31.7209 38.4335 34.2095 35.68L13.9559 15.4265ZM0.421875 52.7333C1.21403 64.4914 6.14754 75.1142 13.7759 83.1554L34.0346 62.8968C31.5595 60.087 29.8439 56.5922 29.2085 52.7333H0.421875ZM15.6162 84.9956C23.6575 92.6237 34.2804 97.5569 46.0384 98.3488V69.5622C42.1796 68.9271 38.6848 67.2117 35.8749 64.7369L15.6162 84.9956ZM53.1023 98.3225C64.8056 97.4461 75.3645 92.4651 83.3441 84.8147L63.0906 64.5611C60.3374 67.0495 56.9037 68.7991 53.1023 69.4974V98.3225ZM85.1746 82.9647C92.7006 74.9466 97.5628 64.3986 98.3487 52.7333H69.5599C68.9395 56.5014 67.289 59.9223 64.9072 62.6973L85.1746 82.9647ZM98.3225 45.6694C97.4532 34.0582 92.5437 23.5734 84.9956 15.6163L64.7347 35.8771C67.1299 38.5966 68.8138 41.9577 69.4954 45.6694H98.3225ZM83.1553 13.776C75.1984 6.22751 64.7135 1.31773 53.1023 0.448198V29.2754C56.8141 29.9572 60.1751 31.6413 62.8946 34.0368L83.1553 13.776Z' fill='%23F8F8F8'/%3E%3C/svg%3E");
  background-color: #FFFFFF;
  background-repeat: no-repeat;
  background-position: 15px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  z-index: 10;
  @media (max-width: $mobile) {
    display: none;
  }
}

.map-frame {
  width: 100%;
  height: 50px;
  border: 3px solid rgba(115, 103, 240, 0.12);
  position: absolute;
  top: 0;
  left: 0;
  cursor: move;
}

.tickets-panel {
  position: absolute;
  height: 88px;
  background: #ffffff;
  width: 100%;
  left: 0;
  bottom: 0;
  box-shadow: 0px 4px 24px rgb(0 0 0 / 6%);
  padding: 25px;
  display: flex;
  @media (max-width: $mobile) {
    display: none;
  }
}

.tickets-panel-mob {
  display: none;
  text-align: center;
  padding: 20px;
  box-shadow: 0px -5px 20px 0px rgba(0, 0, 0, 0.1);
  z-index: 1;
  position: relative;

  &__dop {
    position: absolute;
    bottom: 78px;
    background-color: #fff;
    width: 100%;
    height: auto;
    padding: 20px 20px 0;
    left: 0;
    right: 0;
    box-shadow: 0px -20px 20px 0px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: $mobile) {
    display: block;
  }
}

.tickets-list-overflow {
  max-height: 210px;
  overflow: auto;
  display: none;
}

.tickets-list-overflow.show {
  display: block;
}

.tickets-list {
  position: absolute;
  bottom: 19px;
}

.tickets-list-order {
  text-align: left;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tickets-list-order svg {
  width: 24px;
  height: 24px;
  transition: .3s ease;
}

.tickets-list-order.open svg {
  transform: rotate(180deg);
  transition: .3s ease;
}

.similar-title {
  font-weight: 600;
  font-size: 14px;
  color: #6E6B7B;
  margin-bottom: 30px;
}

.similar-wrp {
  overflow: hidden;
  height: calc(100% - 50px);
}

.similar-body {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  margin: 0 -35px;
  padding: 0 35px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #ebe9f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #7367f0;
    opacity: .5;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 1;
  }

  @media (max-width: $mobile) {
    margin: 0 -10px;
    padding: 0 10px;
  }
}

.similar-item {
  margin: 0 -35px;
  padding: 20px 35px;
  border-top: solid 1px #EBE9F1;
}

.similar-item:last-child {
  border-bottom: solid 1px #EBE9F1;
}

.map-with-details {
  height: 100%;
  display: flex;
  flex-direction: column;

  &__price-list {
    margin-top: 1.5rem;
    position: relative;
    padding-bottom: 15px;

    &:after {
      content: '';
      position: absolute;
      bottom: -60px;
      left: 0;
      width: 100%;
      height: 60px;
      background: linear-gradient(rgb(255, 255, 255) 0, rgba(255, 255, 255, .7) 40%, rgba(255, 255, 255, 0.4) 60%, rgba(255, 255, 255, 0) 100%);
      z-index: 1;
      pointer-events: none;
    }

    span {
      font-size: 12px;
      line-height: 18px;
      cursor: pointer;
      border-radius: 17px;
      padding: 1px 8px;
      margin: 0 4px 10px;
      border: 1px solid;
      &.active {
        background-color: #fff!important;
        color: inherit;
        border: 1px solid;
        border-color: inherit;
      }

      &:hover {
        opacity: .8;
      }
    }
  }

  @media (max-width: $mobile) {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
  }
}

.map-zoom {
  display: none;
  width: 40px;
  height: 40px;
  border: solid 1px #7465ef;
  background: rgba(108, 117, 125, 0.12);
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: 20px;
  text-align: center;
  font-size: 30px;
  line-height: 28px;
  z-index: 5;
  @media (max-width: $mobile) {
    display: block;
  }
}

.map-zoom.map-zoom-plus {
  transform: translateX(-60px);
}

.map-zoom-container {
  height: 0;
  width: 100%;
  position: relative;
}

.modal-attention {
  width: 100%;
  max-width: 358px;
  margin: 0 auto;
  padding: 37px 24px;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  display: none;

  &.maxticketsbuy {
    display: block;
  }

  &.show {
    display: block;
  }

  &.long {
    max-width: 576px;

    a {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }

  &__header {
    margin-bottom: 15px;
    text-align: center;
  }

  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #5E5873;
  }

  &__body {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: left;
    color: #6E6B7B;
    margin-bottom: 24px;

    p {
      margin: 0 0 16px;
    }
  }

  &__footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}
.modal-corporate{
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 20;
  background-color: rgba(64, 59, 82, 0.91);
  display: flex;
  &.show {
    display: block;
  }

  &__inner{
    max-width: 358px;
    background-color: #fff;
    position: relative;
    margin: auto;
    padding: 37px 24px;
    border-radius: 6px;
  }

  &__header {
    margin-bottom: 15px;
    text-align: center;
  }

  &__close{
    position: absolute;
    top: -60px;
    right: 0;
    z-index: 10;
    background-color: #ffffff;
    box-shadow: 0 3px 8px rgba(167, 174, 181, 0.4);
    &:hover{
      opacity: .7;
      &:not(.disabled):not(:disabled) {
        background-color: #ffffff;
      }
    }
    @media (max-width: $mobile) {
      top: 10px;
      right: 10px;
    }
  }

  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #5E5873;
  }

  &__body {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: left;
    color: #6E6B7B;
    p {
      margin: 0 0 16px;
    }
  }
}

.swiper-slide {
  width: auto;
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>

<style lang="scss">
$mobile: 899px;
.map-overflow .map-tooltip {
  @media (max-width: $mobile) {
    display: none;
  }
}

html[dir] body {
  background-color: transparent;
}

html, body {
  background-color: transparent !important;
  overflow: hidden;
  height: 100%;
  max-height: 100%;
}
</style>
